import { makeAutoObservable, runInAction } from 'mobx';

import { IBaseStore } from '~base/types/BaseTypes';
import FileTypesService from '~modules/fileTypes/FileTypesService';
import { DocumentFixedTypeModel } from '~modules/fileTypes/models/DocumentFixedTypeModel';
import { FileFormatModel } from '~modules/fileTypes/models/FileFormatModel';
import { FileModeEnum } from '~modules/fileTypes/types/FileModeEnum';

export class FileTypesStore implements IBaseStore {
  fileFormats: FileFormatModel[] = [];
  fileFormatsLoading: boolean = false;
  fileFormatsLoaded: boolean = false;

  documentFixedTypes: DocumentFixedTypeModel[] = [];
  documentFixedTypesLoading: boolean = false;
  documentFixedTypesLoaded: boolean = false;

  private service: FileTypesService;

  constructor() {
    makeAutoObservable(this);

    this.service = new FileTypesService();
  }

  // API

  getFileFormats = (mode: FileModeEnum) => {
    this.fileFormatsLoading = true;

    this.service
      .getFileFormats(mode)
      .then((items) =>
        runInAction(() => {
          this.fileFormats = items;
          this.fileFormatsLoaded = true;
        }),
      )
      .catch(() =>
        runInAction(() => {
          this.fileFormatsLoaded = false;
        }),
      )
      .finally(() =>
        runInAction(() => {
          this.fileFormatsLoading = false;
        }),
      );
  };

  getDocumentFixedTypes = (
    documentTypeId: number,
    documentId: number | undefined,
    mode: FileModeEnum,
    includeNonGroupType?: boolean,
  ) => {
    this.documentFixedTypesLoading = true;

    this.service
      .getDocumentFixedTypes(documentTypeId, documentId, mode, includeNonGroupType)
      .then((items) =>
        runInAction(() => {
          this.documentFixedTypes = items;
          this.documentFixedTypesLoaded = true;
        }),
      )
      .catch(() =>
        runInAction(() => {
          this.documentFixedTypesLoaded = false;
        }),
      )
      .finally(() =>
        runInAction(() => {
          this.documentFixedTypesLoading = false;
        }),
      );
  };

  // RESET

  resetFileFormats = () => {
    this.fileFormats = [];
    this.fileFormatsLoading = false;
    this.fileFormatsLoaded = false;
  };

  resetDocumentFixedTypes = () => {
    this.documentFixedTypes = [];
    this.documentFixedTypesLoading = false;
    this.documentFixedTypesLoaded = false;
  };

  reset = () => {
    this.resetFileFormats();
    this.resetDocumentFixedTypes();
  };
}
